import { Button, Label, Modal } from '@lego/connect-components-react';
import { Radio, RadioGroup, Stack, Text } from '@lego/klik-ui';
import { type RefObject, useState } from 'react';
import type { DownloadOption } from '../types/create-price-table-types';

type PriceDownloadModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
  onSubmit: (selectedDownloadOption: DownloadOption) => void;
};

const PriceDownloadModal = ({
  isOpen,
  triggerRef,
  onClose,
  onSubmit,
}: PriceDownloadModalProps) => {
  const [selectedDownloadOption, setSelectedDownloadOption] =
    useState<DownloadOption>('filtered');
  const handleClose = () => {
    setSelectedDownloadOption('filtered');
    onClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="medium"
      triggerRef={triggerRef}
    >
      <Modal.Title>Download Excel file</Modal.Title>
      <Modal.Content>
        <Label>Choose what you'd like to include in your download file.</Label>
        <RadioGroup defaultValue="filtered" name="download-option">
          <Stack>
            <Radio
              isDisabled={false}
              value="filtered"
              name="download-option-filtered"
              onChange={() => setSelectedDownloadOption('filtered')}
            >
              <Text fontWeight={700}>Visible data</Text>
              <Text fontWeight={400}>
                Only current filtered rows and visible columns.
              </Text>
            </Radio>
            <Radio
              isDisabled={false}
              value="all"
              name="download-option-all"
              onChange={() => setSelectedDownloadOption('all')}
            >
              <Text fontWeight={700}>All data</Text>
              <Text fontWeight={400}>
                Including filtered out rows and hidden columns.
              </Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </Modal.Content>
      <Modal.Footer>
        <Button appearance="ghost" variant="neutral" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          appearance="solid"
          onClick={() => {
            onSubmit(selectedDownloadOption);
            handleClose();
          }}
        >
          Download Excel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PriceDownloadModal;
